import { ProfileMenuController } from './controllers/ProfileMenuController.js';
import { BasePage } from '../../base/BasePage.js';

export class ProfilePublicationsPage extends BasePage {
    constructor() {

        super();


        const token = window.appData?.token;
        const authorId = window.appData?.authorId;


        this.initResource({
            controller: new ProfileMenuController(),
            event: 'profile.menu',
            cacheKey: `profile.menu.${authorId}`,
            payload: { token, authorId }
        });

    }
}